import { z } from '@harvestiq/zod';

export const unsubscribeParamsSchema = z.object({
  campaignId: z.string().uuid(),
  userId: z.string().uuid().optional(),
});

export type UnsubscribeParams = z.infer<typeof unsubscribeParamsSchema>;
